import api from './client';

export interface PriceSize {
  id: number;
  volume: number;
  unit: string;
  price: number | null;
}

export interface PriceProduct {
  id: number;
  catalog_id: number | null;
  brand: string;
  model_name: string | null;
  price_name: string;
  group_name: string | null;
  bulk_price_per_liter: number | null;
  source_file: string;
  valid_from: string | null;
  sizes: PriceSize[];
}

export interface PriceListParams {
  brand?: string;
  group?: string;
  search?: string;
  unmatched?: boolean;
}

export const getPriceProducts = (params: PriceListParams = {}) =>
  api.get<PriceProduct[]>('/price-list/products', { params }).then(r => r.data);
